import { render, staticRenderFns } from "./BuyBtn.vue?vue&type=template&id=6073d3d2"
import script from "./BuyBtn.vue?vue&type=script&lang=js"
export * from "./BuyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports